import {get, post} from "@/config/api";

const state = {
};

const getters = {
};

const mutations = {
};

const actions = {

  UpdateItemList({}, params) {
    return new Promise((resolve, reject) => {
      get("ugc/item_list/add/", params).then((data) => {
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },

};

export default {
  state,
  getters,
  actions,
  mutations,
};
